import { render, staticRenderFns } from "./UsuarioCompras.vue?vue&type=template&id=6570dba3&scoped=true&"
import script from "./UsuarioCompras.vue?vue&type=script&lang=js&"
export * from "./UsuarioCompras.vue?vue&type=script&lang=js&"
import style0 from "./UsuarioCompras.vue?vue&type=style&index=0&id=6570dba3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6570dba3",
  null
  
)

export default component.exports